import { render, staticRenderFns } from "./SignerRolesView.vue?vue&type=template&id=765fe2d1"
import script from "./SignerRolesView.vue?vue&type=script&lang=js"
export * from "./SignerRolesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports